import React, { Component } from 'react';
import { roundigFormat } from "../libs/utils/Operations";
import $ from "jquery";
import { ApiClient } from "../libs/apiClient";
let apiClient = ApiClient.getInstance();
class BillingResponseModal extends Component {


    constructor(props) {
        super(props)

        this.state = {
            comments: []
        }

    }

    componentDidMount() {
        const { refreshTable } = this.props;

        $('#billingResponseModal').on('hidden.bs.modal', function () {
            refreshTable()
        })
    }
    comments = (event, index, id) => {
        const { comments } = this.state
        let comm = event.nativeEvent.target.value;
        let comment = comments || [];
        let exist = false;
        for (var i = 0; i < comment.length; i++) {
            if (i == index) {
                comment[i] = { commnet: comm, ID: id };
                exist = true;
                break;
            }
        }
        if (!exist) {
            comment.push({ commnet: comm, ID: id });
        }
        this.setState({
            comments: comment
        });

    }
    sendComments = async () => {
        const { comments } = this.state;
        const { array } = this.props;
        let docEntry = array[0].docEntry || '';
        if (comments.length > 0) {
            await apiClient.setCommentsAutorizations(comments, docEntry);
            this.setState({
                comments: []
            });
            $('#billingResponseModal').modal('hide');
        }
        else {
            $('#billingResponseModal').modal('hide');
        }

    }

    renderTableResponseBilling = () => {
        const { array } = this.props;

        let header = "";
        let body = "";

        header = <tr style={{ maxWidth: 50 }}>
            <td className="sticky-header" style={{ backgroundColor: "#e9ecef", textAlign: "center" }}>
                Documento
            </td>
            <td className="sticky-header" style={{ backgroundColor: "#e9ecef", textAlign: "center" }}>
                Mensaje
            </td>
            <td className="sticky-header" style={{ backgroundColor: "#e9ecef", textAlign: "center" }}>
                Resultado
            </td>
        </tr>;


        let autorizations = array.length ? array[0].array ? array[0].array : null : null;
        const listItems = autorizations ? autorizations.map((d, index) => {
            return <td className="sticky-column" style={{ textAlign: "justify" }}>
                <tr key={index}>{d.name}</tr>
                <tr key={index}><input type="text" className="form-control" onChange={event => this.comments(event, index, d.id)} /></tr>
            </td>

        }) : [];
        body = array.map((register, index) => {
            return (
                <tr key={index}>
                    <td className="sticky-column" style={{ textAlign: "center" }}>
                        {register.docNum || ''}
                    </td>

                    <td className="sticky-column" >
                        <tr className="sticky-column" style={{ textAlign: "justify" }}>
                            {register.message || ''}
                        </tr>
                        {
                            listItems
                        }
                        {listItems.length > 0 &&
                            <tr className="sticky-column" style={{ alignItems: "center" }}>
                                <td className="sticky-column" style={{ textAlign: "center" }}>
                                </td>
                                <td className="sticky-column" style={{ textAlign: "center" }}>
                                    <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#000000' }} onClick={this.sendComments}>Enviar</button>
                                </td>
                                <td className="sticky-column" style={{ textAlign: "center" }}>
                                </td>



                            </tr>
                        }

                    </td>
                    <td className="sticky-column" style={{ textAlign: "center" }}>
                        {register.billing || ''}
                    </td>
                </tr>


            )
        })

        let table = "";

        table = <table id="billingResponseModalTable" className="display" style={{ width: '100%' }}>
            <thead className="table-header">
                {header}
            </thead>
            <tbody>
                {body}
            </tbody>
        </table>;

        return table;
    }

    // <div className="modal-content" style={{width: 800, maxWidth: 800}}>

    render() {
        return (
            <div className="modal fade bd-example-modal-xl bgtransparent" data-target=".bd-example-modal-lg" id="billingResponseModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title "></h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div style={{ height: 250, overflowX: 'auto' }}>
                                            <div>
                                                {this.renderTableResponseBilling()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" data-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BillingResponseModal;